import mergeConfig from 'coact/config/mergeConfig'

import Page from './Page/index.js'

const config = {
  routes: {
    stockState: {
      title: '商品庫存價格查詢',
      path: '/route/stockState',
      component: Page,
    },
  },
  // sagas: {
  //   referenceQuerySaga: require('./saga').default,
  // },
}

export default fullConfig => mergeConfig(fullConfig, config)
